"use strict";
!function(t) {
    window.TabKeyController = function(t) {
        this._init(t)
    }
    ,
    t.extend(TabKeyController.prototype, {
        $options: {
            private: {
				skip: false,
				value: null,
			}
        },
        
		selectClosing: function (e) {
			this.$options.private.value = $('input.select2-search__field').val();
		},

		selectLeave: function (e) {
			var keyCode = e.keyCode || e.which;
			if (9 == keyCode) {	//TAB
				var $focus = $(':focus'),
					$select = $focus.parent().parent().prev(),
					value = this.$options.private.value,
					option = new Option(value, value, true, true);
				
				$select.append(option).trigger('change');
				
				this.$options.private.value = null;
				this.$options.private.skip = true;
			}
		},

		selectFocused: function (e) {
			var keyCode = e.keyCode || e.which;
			if (9 == keyCode) {	//TAB
				if (!this.$options.private.skip) {
					var app = this,
						$focus = $(':focus');

					if ($focus.hasClass('select2-selection')) {
						var $select = $focus.parent().parent().prev();
						$select.select2('open');
						app.$options.private.closedSelect = null;
					}
				} else {
					this.jumpNext($(':focus'), e.shiftKey);
					this.$options.private.skip = false;
				}
			}
		},

		jumpNext: function($focus, prev) {
			if ($focus.hasClass('select2-selection'))
			{
				var $select = $focus.parent().parent().prev(),
					name = $select.attr('name'),
					select = $select.get(0),
					form = (select ? select.form : null);
				if (form)
				{
					var i = (form.elements.length - 1);
					$.each(form.elements, function (index, element) {
						if (element.name == name)
						{
							if (prev && (index > 0))
							{
								i = index - 1;
							}
							else if (!prev && (index < i))
							{
								i = index + 1;
							}
							return false;
						}
					});
					var $el = $(form.elements[i]);
					if (!$el.hasClass('select2-hidden-accessible'))
					{
						$el.focus();
					}
					else 
					{
						$el.focus();
						$el.select2('open');
					}
				}
			}
		},
		
        handleButtons: function () {
        	var $document = $(document),
        		app = this;
        	
        	$document.on('keydown', '.select2-search__field', function (e) {
        		app.selectLeave(e);
        	});
			$document.on('keyup', function (e) {
				app.selectFocused(e);
			});
			$document.on('select2:closing', function (e) {
				app.selectClosing(e);
			})
        },
        _init: function(e) {
            this.$options = t.extend({}, this.$options, e || {}),
            this.handleButtons();
        }
    })
}(jQuery);
